var _line, _path, _path2, _line2, _line3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionarePrinProtectiaElectromagneticaLaSupracurent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 81,
    viewBox: "0 0 76 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 38,
    x2: 52,
    y2: 38,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 34.5L37 0",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 81L37 42.5",
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 38,
    x2: 76,
    y2: 38,
    stroke: "black",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: 38,
    x2: 64,
    y2: 38,
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 43C39.2091 43 41 40.9853 41 38.5C41 36.0147 39.2091 34 37 34",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionarePrinProtectiaElectromagneticaLaSupracurent);
export default __webpack_public_path__ + "static/media/actionare_prin_protectia_electromagnetica_la_supracurent.cf24dd06e576be2c3e2c8a5dd6d9ce4b.svg";
export { ForwardRef as ReactComponent };